// Display categories checked against TYC JNDEB drawExtMap (ZHUHE/JIDX/SWXT).
export function pc28Display(numbers) {
  const total = numbers.reduce((sum,n)=>sum+n,0);
  const sorted = [...numbers].sort((a,b)=>a-b);
  const unique = new Set(numbers).size;
  return {
    total,
    combination: `${total>=14?'大':'小'}${total%2?'单':'双'}`,
    extreme: total<=5?'极小':total>=22?'极大':'—',
    shape: unique===1?'豹子':unique===2?'对子':sorted[1]===sorted[0]+1&&sorted[2]===sorted[1]+1?'顺子':'—',
  };
}
